<div class="storeNameOuter" *ngIf="superAdminLoggedIn">
  <span class="storeName">
    <i class="fa fa-dot-circle-o pulsate"></i>
    {{storeName?.split('.')[0]}}
  </span>
</div>

<div class="content-blk">
  <div class="sp-admin-list-outer-page">
    <div class="container">
      <!-- Header Section -->
      <div class="st-top-head spc-top-head-lt">
        <div class="row">
          <div class="col-sm-6">
            <div class="srch-flt-rt">
              <h2>{{ isEditMode ? 'Edit Product - Design Preview' : 'Design Preview' }}</h2>
              <p class="text-muted">{{ isEditMode ? 'Review your current design or change it' : 'Review your design before continuing' }}</p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="text-right">
              <button mat-raised-button class="mat-btn btn-back" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="white-background design-preview-content">
        <!-- Design Selected Banner -->
        <div class="design-selected-banner">
          <div class="banner-icon">
            <i class="fa fa-check-circle"></i>
          </div>
          <div class="banner-content">
            <h3>Design Selected</h3>
            <p class="design-name">{{selectedDesign?.name || selectedFile?.name}}</p>
          </div>
        </div>

        <!-- Design Preview Section -->
        <div class="preview-section">
          <div class="row">
            <!-- Left Column - Design Preview -->
            <div class="col-md-8">
              <div class="preview-card">
                <div class="preview-header">
                  <h4>Design Preview</h4>
                </div>

                <div class="preview-image-container">
                  <!-- A PDF cannot be decoded by <img>, so page 1 is rasterized to a PNG first and
                       bound here like any other design. -->
                  <img
                    *ngIf="isPdfDesign && pdfImageUrl"
                    [src]="pdfImageUrl"
                    alt="Design Preview"
                    class="preview-image">

                  <div *ngIf="isPdfDesign && isRenderingPdf" class="preview-placeholder">
                    <i class="fa fa-spinner fa-spin"></i>
                    <p>Rendering preview...</p>
                  </div>

                  <!-- Rasterization failed: fall back to the browser's own PDF viewer. -->
                  <object
                    *ngIf="pdfPreviewUrl"
                    [data]="pdfPreviewUrl"
                    type="application/pdf"
                    class="preview-pdf">
                    <div class="preview-file-tile">
                      <i class="fa fa-file-pdf-o"></i>
                      <p>PDF preview is not available in this browser.</p>
                    </div>
                  </object>

                  <!-- A PDF that can be neither rasterized nor embedded (e.g. a data: URI). -->
                  <div
                    *ngIf="isPdfDesign && !isRenderingPdf && !pdfImageUrl && !pdfPreviewUrl"
                    class="preview-file-tile">
                    <i class="fa fa-file-pdf-o"></i>
                    <p>PDF design</p>
                  </div>

                  <img
                    *ngIf="previewUrl && !isPdfDesign"
                    [src]="previewUrl"
                    alt="Design Preview"
                    class="preview-image">

                  <div *ngIf="!previewUrl" class="preview-placeholder">
                    <i class="fa fa-image"></i>
                    <p>Loading preview...</p>
                  </div>
                </div>

                <div class="preview-info">
                  <div class="info-row">
                    <span class="info-label">File Type:</span>
                    <span class="info-value">{{getFileExtension()}}</span>
                  </div>
                  <div class="info-row" *ngIf="selectedFile">
                    <span class="info-label">File Size:</span>
                    <span class="info-value">{{formatFileSize(selectedFile.size)}}</span>
                  </div>
                  <div class="info-row" *ngIf="selectedDesign">
                    <span class="info-label">Created:</span>
                    <span class="info-value">{{selectedDesign.createdDate | date:'medium'}}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Right Column - Actions -->
            <div class="col-md-4">
              <div class="actions-card">
                <h4>Actions</h4>

                <!-- Change Design Button -->
                <div class="action-item">
                  <button
                    mat-raised-button
                    class="mat-btn btn-change"
                    (click)="changeDesign()">
                    <i class="fa fa-refresh"></i> Change Design
                  </button>
                  <p class="action-description">Select a different design or upload a new one</p>
                </div>

                <!-- Continue Button -->
                <div class="action-item">
                  <button
                    mat-raised-button
                    class="mat-btn mat-primary btn-continue"
                    (click)="continueToProductSelection()">
                    <i class="fa fa-arrow-right"></i> {{ isEditMode ? 'Continue to Edit Product' : 'Continue to Product' }}
                  </button>
                  <p class="action-description">{{ isEditMode ? 'Proceed to update product settings' : 'Proceed to select products for this design' }}</p>
                </div>

                <!-- Design Details -->
                <div class="design-details-section">
                  <h5>Design Details</h5>
                  <div class="detail-item">
                    <i class="fa fa-tag"></i>
                    <span>{{selectedDesign?.name || 'New Upload'}}</span>
                  </div>
                  <div class="detail-item" *ngIf="storeId">
                    <i class="fa fa-store"></i>
                    <span>Store ID: {{storeId}}</span>
                  </div>
                  <div class="detail-item">
                    <i class="fa fa-clock-o"></i>
                    <span>{{getCurrentDateTime()}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Additional Information -->
        <div class="additional-info">
          <div class="info-card">
            <i class="fa fa-info-circle"></i>
            <div class="info-text">
              <h5>Next Steps</h5>
              <p>After continuing, you'll be able to select products and customize how this design appears on each item.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
